<template>
	<v-card>
		<v-form ref="formActual">
			<v-container>
				<v-row :align="'center'">
					<v-col cols="2">
						<v-card-text>Peso a ulitizar</v-card-text>
					</v-col>
					<v-col cols="3">
						<v-text-field
							hide-details="auto"
							suffix="kg"
							solo
							readonly
							:value="peso"
						></v-text-field>
					</v-col>
					<v-col>
						<v-radio-group row mandatory v-model="valor.PesoInfo">
							<v-radio label="Seco" :value="1"></v-radio>
							<v-radio label="Ajustado" :value="2"></v-radio>
							<v-radio label="Ideal" :value="3"></v-radio>
						</v-radio-group>
					</v-col>
				</v-row>
				<v-row :align="'center'">
					<v-col cols="1">
						<v-card-text>Talla</v-card-text>
					</v-col>
					<v-col cols="3">
						<v-text-field
							hide-details="auto"
							solo
							readonly
							suffix="cm"
							:value="talla"
						></v-text-field>
					</v-col>
					<v-col cols="1">
						<v-card-text>Edad</v-card-text>
					</v-col>
					<v-col cols="3">
						<v-text-field
							hide-details="auto"
							solo
							readonly
							suffix="años"
							:value="edad"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row align="'center'">
					<v-col>
						<v-card-text class="v-title"
							>Cálculo de Energía</v-card-text
						>
					</v-col>
				</v-row>
				<v-row align="'center'">
					<v-col cols="2">
						<v-card-text>Ecuación de Vilar</v-card-text>
					</v-col>
					<v-col cols="4">
						<v-text-field
							suffix="kcal"
							:value="valor.EcuacionVilar"
							hide-details="auto"
							solo
							readonly
							class="ma-0 pa-0 pr-4 pt-1"
						></v-text-field>
					</v-col>
					<v-col cols="2">
						<v-card-text>30 kcal/kg</v-card-text>
					</v-col>
					<v-col cols="4">
						<v-text-field
							suffix="kcal"
							:value="valor.KCal30"
							hide-details="auto"
							solo
							readonly
							class="ma-0 pa-0 pr-4 pt-1"
						></v-text-field>
					</v-col>
					<v-col cols="2">
						<v-card-text>35 kcal/kg</v-card-text>
					</v-col>
					<v-col cols="4">
						<v-text-field
							suffix="kcal"
							:value="valor.KCal35"
							hide-details="auto"
							solo
							readonly
							class="ma-0 pa-0 pr-4 pt-1"
						></v-text-field>
					</v-col>
					<v-col cols="2">
						<v-card-text>Harris-Benedict (GEB)</v-card-text>
					</v-col>
					<v-col cols="4">
						<v-text-field
							suffix="kcal"
							v-model="valor.HarrisBenedict"
							hide-details="auto"
							solo
							readonly
							class="ma-0 pa-0 pr-4 pt-1"
						></v-text-field>
					</v-col>
					<v-col cols="2">
						<v-card-text>Recomendación de Energía</v-card-text>
					</v-col>
					<v-col cols="4">
						<v-text-field
							suffix="kcal"
							:rules="[
								!!valor.RecomendacionEnergia ||
									'Campo Obligatorio'
							]"
							hide-details="auto"
							v-model="valor.RecomendacionEnergia"
						></v-text-field>
					</v-col>
					<v-col cols="2">
						<v-card-text>Proteína</v-card-text>
					</v-col>
					<v-col cols="4">
						<v-text-field
							:rules="[!!valor.Proteina || 'Campo Obligatorio']"
							v-model="valor.Proteina"
							hide-details="auto"
							class="ma-0 pa-0 pr-4 pt-1"
							suffix="g/kg/día"
						></v-text-field>
					</v-col>
					<v-col cols="2">
						<v-card-text>Total de Proteína</v-card-text>
					</v-col>
					<v-col cols="4">
						<v-text-field
							solo
							readonly
							:value="valor.TotalProteina"
							suffix="gramos al día"
						></v-text-field>
					</v-col>
				</v-row>
			</v-container>
			<div class="v-title">DISTRIBUCIÓN DE MACRONUTRIMENTOS</div>
			<v-container>
				<v-simple-table>
					<thead>
						<tr>
							<td>Macronutrimento</td>
							<td>Gramos</td>
							<td>Kcal</td>
							<td>%</td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>
								<v-card-text>Proteína</v-card-text>
							</td>
							<td>
								<v-text-field
									:rules="[
										!!valor.ProteinaGramos ||
											'Campo Obligatorio'
									]"
									suffix="gramos"
									v-model="valor.ProteinaGramos"
									hide-details="auto"
									class="ma-0 pa-0 pr-4 pt-1"
								></v-text-field>
							</td>
							<td>
								<v-text-field
									v-model="valor.ProteinaKcal"
									hide-details="auto"
									solo
									readonly
									suffix="kcal"
									class="ma-0 pa-0 pr-4 pt-1"
								></v-text-field>
							</td>
							<td>
								<v-text-field
									suffix="%"
									v-model="valor.ProteinaPorcentaje"
									hide-details="auto"
									solo
									readonly
									class="ma-0 pa-0 pr-4 pt-1"
								></v-text-field>
							</td>
						</tr>
						<tr>
							<td>
								<v-card-text>Hidratos de Carbono</v-card-text>
							</td>
							<td>
								<v-text-field
									suffix="gramos"
									hide-details="auto"
									solo
									readonly
									class="ma-0 pa-0 pr-4 pt-1"
									v-model="valor.HCGramos"
								></v-text-field>
							</td>
							<td>
								<v-text-field
									hide-details="auto"
									solo
									suffix="kcal"
									readonly
									class="ma-0 pa-0 pr-4 pt-1"
									v-model="valor.HCKcal"
								></v-text-field>
							</td>
							<td>
								<v-text-field
									:rules="[
										!!valor.HCPorcentaje ||
											'Campo Obligatorio'
									]"
									suffix="%"
									v-model="valor.HCPorcentaje"
								></v-text-field>
							</td>
						</tr>
						<tr>
							<td class="pb-1">
								<v-card-text>Lípidos</v-card-text>
							</td>
							<td>
								<v-text-field
									suffix="gramos"
									v-model="valor.LipidosGramos"
									hide-details="auto"
									solo
									readonly
									class="ma-0 pa-0 pr-4 pt-1"
								></v-text-field>
							</td>
							<td>
								<v-text-field
									v-model="valor.LipidosKcal"
									hide-details="auto"
									solo
									readonly
									suffix="kcal"
									class="ma-0 pa-0 pr-4 pt-1"
								></v-text-field>
							</td>
							<td>
								<v-text-field
									solo
									hide-details="auto"
									class="ma-0 pa-0 pr-4 pt-1"
									readonly
									suffix="%"
									v-model="valor.LipidosPorcentaje"
								></v-text-field>
							</td>
						</tr>
					</tbody>
				</v-simple-table>
			</v-container>
			<div class="v-title">
				RECOMENDACIÓN DE MICRONUTRIMENTOS Y LÍQUIDOS
			</div>
			<v-container>
				<v-row :align="'center'">
					<v-col cols="2"> Agua </v-col>
					<v-col cols="3">
						<v-text-field
							:rules="[
								!!valor.RecomendacionAgua || 'Campo Obligatorio'
							]"
							hide-details="auto"
							class="campo-formulario"
							v-model="valor.RecomendacionAgua"
							suffix="ml"
						></v-text-field>
					</v-col>
					<v-col cols="2"> Calcio </v-col>
					<v-col cols="3">
						<v-text-field
							:rules="[
								!!valor.RecomendacionCalcio ||
									'Campo Obligatorio'
							]"
							hide-details="auto"
							class="campo-formulario"
							v-model="valor.RecomendacionCalcio"
							suffix="mg"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row :align="'center'">
					<v-col cols="2"> Fósforo </v-col>
					<v-col cols="3">
						<v-text-field
							:rules="[
								!!valor.RecomendacionFosforo ||
									'Campo Obligatorio'
							]"
							hide-details="auto"
							class="campo-formulario"
							v-model="valor.RecomendacionFosforo"
							suffix="mg"
						></v-text-field>
					</v-col>
					<v-col cols="2"> Potasio </v-col>
					<v-col cols="3">
						<v-text-field
							:rules="[
								!!valor.RecomendacionPotasio ||
									'Campo Obligatorio'
							]"
							hide-details="auto"
							class="campo-formulario"
							v-model="valor.RecomendacionPotasio"
							suffix="mg"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row :align="'center'">
					<v-col cols="2"> Sodio </v-col>
					<v-col cols="3">
						<v-text-field
							:rules="[
								!!valor.RecomendacionSodio ||
									'Campo Obligatorio'
							]"
							hide-details="auto"
							class="campo-formulario"
							v-model="valor.RecomendacionSodio"
							suffix="mg"
						></v-text-field>
					</v-col>
				</v-row>
			</v-container>

			<div class="v-title">CÁLCULO DE EQUIVALENTES</div>

			<v-simple-table dense class="table">
				<thead class="v-title-center">
					<tr>
						<th colspan="3"></th>
						<th class="text-center">Energía</th>
						<th colspan="3" class="text-center">
							Macronutrimentos
						</th>
						<th class="text-center">Agua</th>
						<th class="text-center">Calcio</th>
						<th class="text-center">Fósforo</th>
						<th class="text-center">Potasio</th>
						<th class="text-center">Sodio</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td class="font-weight-bold text-center">Grupo</td>
						<td class="font-weight-bold text-center">Tipo</td>
						<td class="font-weight-bold text-center">Cantidad</td>
						<td class="font-weight-bold text-center">KCAL</td>
						<td class="font-weight-bold text-center">Proteína</td>
						<td class="font-weight-bold text-center">Lípidos</td>
						<td class="font-weight-bold text-center">HC</td>
						<td class="font-weight-bold text-center">ml</td>
						<td class="font-weight-bold text-center">mg</td>
						<td class="font-weight-bold text-center">mg</td>
						<td class="font-weight-bold text-center">mg</td>
						<td class="font-weight-bold text-center">mg</td>
					</tr>
					<tr
						v-for="(a, i) in valor.Alimentos"
						:key="i"
						:class="{ 'borde-inferior': ponerBordeInferior(a) }"
					>
						<td
							class="font-weight-medium text-center"
							v-if="getRowSpan(a) > 0"
							:rowspan="getRowSpan(a)"
						>
							{{ a.Grupo }}
						</td>
						<td class="font-weight-medium">
							{{ a.Tipo }}
						</td>
						<td width="100" class="pb-1">
							<v-text-field
								hide-details="auto"
								v-model="a.Cantidad"
								@change="calcularTabla"
								type="number"
							>
							</v-text-field>
						</td>
						<td class="text-center">
							{{ a.KCal * a.Cantidad }}
						</td>
						<td class="text-center">
							{{ a.Proteina * a.Cantidad }}
						</td>
						<td class="text-center">
							{{ a.Lipidos * a.Cantidad }}
						</td>
						<td class="text-center">
							{{ a.HC * a.Cantidad }}
						</td>
						<td class="text-center">
							{{ a.Agua * a.Cantidad }}
						</td>
						<td class="text-center">
							{{ a.Calcio * a.Cantidad }}
						</td>
						<td class="text-center">
							{{ a.Fosforo * a.Cantidad }}
						</td>
						<td class="text-center">
							{{ a.Potasio * a.Cantidad }}
						</td>
						<td class="text-center">
							{{ a.Sodio * a.Cantidad }}
						</td>
					</tr>
					<tr class="borde-inferior">
						<td colspan="2" class="pa-2">
							<v-autocomplete
								:items="catalogos.Suplementos"
								return-object
								item-text="Nombre"
								v-model="valor.Suplemento"
								clearable
								label="Suplemento"
								hide-details="auto"
							></v-autocomplete>
						</td>
						<template v-if="valor.Suplemento">
							<td width="100" class="pb-1">
								<v-text-field
									hide-details="auto"
									v-model="valor.Suplemento.Cantidad"
									type="number"
								>
								</v-text-field>
							</td>
							<td class="text-center">
								{{
									valor.Suplemento.KCal *
										valor.Suplemento.Cantidad
								}}
							</td>
							<td class="text-center">
								{{
									valor.Suplemento.Proteina *
										valor.Suplemento.Cantidad
								}}
							</td>
							<td class="text-center">
								{{
									valor.Suplemento.Lipidos *
										valor.Suplemento.Cantidad
								}}
							</td>
							<td class="text-center">
								{{
									valor.Suplemento.HC *
										valor.Suplemento.Cantidad
								}}
							</td>
							<td class="text-center">
								{{
									valor.Suplemento.Agua *
										valor.Suplemento.Cantidad
								}}
							</td>
							<td class="text-center">
								{{
									valor.Suplemento.Calcio *
										valor.Suplemento.Cantidad
								}}
							</td>
							<td class="text-center">
								{{
									valor.Suplemento.Fosforo *
										valor.Suplemento.Cantidad
								}}
							</td>
							<td class="text-center">
								{{
									valor.Suplemento.Potasio *
										valor.Suplemento.Cantidad
								}}
							</td>
							<td class="text-center">
								{{
									valor.Suplemento.Sodio *
										valor.Suplemento.Cantidad
								}}
							</td>
						</template>
					</tr>
					<tr class="borde-inferior">
						<td colspan="2" class="pa-2">
							<v-text-field
								label="Suplementos Otros"
								clearable
								v-model="valor.SuplementosOtros"
								hide-details="auto"
							></v-text-field>
						</td>
						<td></td>
						<template v-if="valor.SuplementosOtros">
							<td class="text-center" width="125">
								<v-text-field
									hide-details="auto"
									v-model="valor.SuplementosOtros_KCal"
									type="number"
								>
								</v-text-field>
							</td>
							<td class="text-center" width="130">
								<v-text-field
									hide-details="auto"
									v-model="valor.SuplementosOtros_Proteina"
									type="number"
								>
								</v-text-field>
							</td>
							<td class="text-center" width="130">
								<v-text-field
									hide-details="auto"
									v-model="valor.SuplementosOtros_Lipidos"
									type="number"
								>
								</v-text-field>
							</td>
							<td class="text-center" width="130">
								<v-text-field
									hide-details="auto"
									v-model="valor.SuplementosOtros_HC"
									type="number"
								>
								</v-text-field>
							</td>

							<td class="text-center" width="130">
								<v-text-field
									hide-details="auto"
									v-model="valor.SuplementosOtros_Agua"
									type="number"
								>
								</v-text-field>
							</td>
							<td class="text-center" width="130">
								<v-text-field
									hide-details="auto"
									v-model="valor.SuplementosOtros_Calcio"
									type="number"
								>
								</v-text-field>
							</td>
							<td class="text-center" width="130">
								<v-text-field
									hide-details="auto"
									v-model="valor.SuplementosOtros_Fosforo"
									type="number"
								>
								</v-text-field>
							</td>
							<td class="text-center" width="130">
								<v-text-field
									hide-details="auto"
									v-model="valor.SuplementosOtros_Potasio"
									type="number"
								>
								</v-text-field>
							</td>
							<td class="text-center" width="130">
								<v-text-field
									hide-details="auto"
									v-model="valor.SuplementosOtros_Sodio"
									type="number"
								>
								</v-text-field>
							</td>
						</template>
					</tr>
					<tr>
						<td class="text-center font-weight-medium">Total</td>
						<td colspan="2"></td>
						<td class="text-center font-weight-bold">
							{{ valor.Totales.KCal }}
						</td>
						<td class="text-center font-weight-bold">
							{{ valor.Totales.Proteina }}
						</td>
						<td class="text-center font-weight-bold">
							{{ valor.Totales.Lipidos }}
						</td>
						<td class="text-center font-weight-bold">
							{{ valor.Totales.HC }}
						</td>
						<td class="text-center font-weight-bold">
							{{ valor.Totales.Agua }}
						</td>
						<td class="text-center font-weight-bold">
							{{ valor.Totales.Calcio }}
						</td>
						<td class="text-center font-weight-bold">
							{{ valor.Totales.Fosforo }}
						</td>
						<td class="text-center font-weight-bold">
							{{ valor.Totales.Potasio }}
						</td>
						<td class="text-center font-weight-bold">
							{{ valor.Totales.Sodio }}
						</td>
					</tr>
					<tr>
						<td class="font-weight-medium text-center">
							% Adecuación
						</td>
						<td colspan="2"></td>
						<td class="text-center font-weight-bold">
							{{ valor.Adecuaciones.KCal }}
						</td>
						<td class="text-center font-weight-bold">
							{{ valor.Adecuaciones.Proteina }}
						</td>
						<td class="text-center font-weight-bold">
							{{ valor.Adecuaciones.Lipidos }}
						</td>
						<td class="text-center font-weight-bold">
							{{ valor.Adecuaciones.HC }}
						</td>
						<td class="text-center font-weight-bold">
							{{ valor.Adecuaciones.Agua }}
						</td>
						<td class="text-center font-weight-bold">
							{{ valor.Adecuaciones.Calcio }}
						</td>
						<td class="text-center font-weight-bold">
							{{ valor.Adecuaciones.Fosforo }}
						</td>
						<td class="text-center font-weight-bold">
							{{ valor.Adecuaciones.Potasio }}
						</td>
						<td class="text-center font-weight-bold">
							{{ valor.Adecuaciones.Sodio }}
						</td>
					</tr>
				</tbody>
			</v-simple-table>
			<div class="v-title">PLAN TERAPÉUTICO</div>
			<v-container>
				<v-row :align="'center'">
					<v-col cols="auto">
						Tipo de dieta y prescripción nutricional
					</v-col>
					<v-col cols="3">
						<v-text-field
							hide-details="auto"
							:rules="[!!valor.TipoDieta || 'Campo Obligatorio']"
							v-model="valor.TipoDieta"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row :align="'center'">
					<v-col cols="auto"> Líquidos totales </v-col>
					<v-col cols="3">
						<v-text-field
							suffix="ml"
							hide-details="auto"
							:rules="[
								!!valor.LiquidosTotales || 'Campo Obligatorio'
							]"
							v-model="valor.LiquidosTotales"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row :align="'center'">
					<v-col cols="auto"> Educación Alimentaria </v-col>
					<v-col cols="3">
						<v-textarea
							hide-details="auto"
							:rules="[
								!!valor.EducacionAlimentaria ||
									'Campo Obligatorio'
							]"
							v-model="valor.EducacionAlimentaria"
						></v-textarea>
					</v-col>
				</v-row>
			</v-container>
		</v-form>
		<v-layout row class="mt-3" v-if="!esVisita">
			<v-flex xs6>
				<v-btn color="primary" large @click.prevent="anterior">
					<v-icon>arrow_back_ios</v-icon> ANTERIOR
				</v-btn>
			</v-flex>
			<v-flex xs6 class="text-right">
				<v-btn color="primary" large @click.prevent="guardar">
					<v-icon>save</v-icon> GUARDAR
				</v-btn>
			</v-flex>
		</v-layout>
	</v-card>
</template>

<script>
import ServicioHistorialClinico from "../../../services/historialClinico";
export default {
	props: [
		"datos",
		"datosAntropometricos",
		"edad",
		"esHombre",
		"esVisita",
		"validateForm"
	],
	name: "planTerapeuticoInfo",
	data() {
		return {
			catalogos: {
				Suplementos: [
					{
						Nombre: "Nepro HP (237 ml)",
						KCal: 434,
						Proteina: 19.2,
						Lipidos: 22.8,
						HC: 38,
						Agua: 172.3,
						Calcio: 251,
						Fosforo: 171,
						Potasio: 251,
						Sodio: 251,
						Cantidad: 0
					},
					{
						Nombre: "Nepro LP (237 ml)",
						KCal: 475,
						Proteina: 7.1,
						Lipidos: 22.7,
						HC: 60.6,
						Agua: 169,
						Calcio: 330,
						Fosforo: 175,
						Potasio: 265,
						Sodio: 185,
						Cantidad: 0
					},
					{
						Nombre: "Enterex RNL (237 ml)",
						KCal: 480,
						Proteina: 20,
						Lipidos: 20,
						HC: 56,
						Agua: 161,
						Calcio: 150,
						Fosforo: 140,
						Potasio: 140,
						Sodio: 240,
						Cantidad: 0
					},
					{
						Nombre: "Fressuport RNL (66 g)",
						KCal: 275.5,
						Proteina: 20,
						Lipidos: 16.6,
						HC: 21.6,
						Agua: 230,
						Calcio: 976,
						Fosforo: 131,
						Potasio: 89.1,
						Sodio: 17.9,
						Cantidad: 0
					},
					{
						Nombre: "Ensure Regular (237 ml)",
						KCal: 254,
						Proteina: 9,
						Lipidos: 6,
						HC: 41,
						Agua: 230,
						Calcio: 127,
						Fosforo: 131,
						Potasio: 89.1,
						Sodio: 17.9,
						Cantidad: 0
					},
					{
						Nombre: "RenNut (70 g)",
						KCal: 380,
						Proteina: 5,
						Lipidos: 32,
						HC: 18,
						Agua: 150,
						Calcio: 59,
						Fosforo: 98,
						Potasio: 183,
						Sodio: 96,
						Cantidad: 0
					},
					{
						Nombre: "Supportan (200 ml)",
						KCal: 300,
						Proteina: 20,
						Lipidos: 13.4,
						HC: 24.8,
						Agua: 152,
						Calcio: 406,
						Fosforo: 240,
						Potasio: 256,
						Sodio: 95,
						Cantidad: 0
					}
				]
			},
			valor: {
				PesoInfo: 1,
				Totales: {},
				Adecuaciones: {},
				Alimentos: [
					{
						Tipo: "Bajo",
						Cantidad: 0,
						KCal: 25,
						Proteina: 2,
						Lipidos: 0,
						HC: 4,
						Agua: 150,
						Calcio: 0,
						Fosforo: 0,
						Potasio: 100,
						Sodio: 0,
						Grupo: "Verduras"
					},
					{
						Tipo: "Moderado",
						Cantidad: 0,
						KCal: 25,
						Proteina: 2,
						Lipidos: 0,
						HC: 4,
						Agua: 150,
						Calcio: 0,
						Fosforo: 0,
						Potasio: 185,
						Sodio: 0,
						Grupo: "Verduras"
					},
					{
						Tipo: "Alto",
						Cantidad: 0,
						KCal: 25,
						Proteina: 2,
						Lipidos: 0,
						HC: 4,
						Agua: 150,
						Calcio: 0,
						Fosforo: 0,
						Potasio: 340,
						Sodio: 0,
						Grupo: "Verduras"
					},
					{
						Tipo: "Bajo",
						Cantidad: 0,
						KCal: 60,
						Proteina: 0,
						Lipidos: 0,
						HC: 15,
						Agua: 200,
						Calcio: 0,
						Fosforo: 0,
						Potasio: 100,
						Sodio: 0,
						Grupo: "Frutas"
					},
					{
						Tipo: "Moderado",
						Cantidad: 0,
						KCal: 60,
						Proteina: 0,
						Lipidos: 0,
						HC: 15,
						Agua: 200,
						Calcio: 0,
						Fosforo: 0,
						Potasio: 185,
						Sodio: 0,
						Grupo: "Frutas"
					},
					{
						Tipo: "Alto",
						Cantidad: 0,
						KCal: 60,
						Proteina: 0,
						Lipidos: 0,
						HC: 15,
						Agua: 200,
						Calcio: 0,
						Fosforo: 0,
						Potasio: 340,
						Sodio: 0,
						Grupo: "Frutas"
					},
					{
						Tipo: "Bajo",
						Cantidad: 0,
						KCal: 70,
						Proteina: 2,
						Lipidos: 0,
						HC: 15,
						Agua: 0,
						Calcio: 0,
						Fosforo: 20,
						Potasio: 0,
						Sodio: 50,
						Grupo: "Cereal s/g"
					},
					{
						Tipo: "Alto",
						Cantidad: 0,
						KCal: 70,
						Proteina: 2,
						Lipidos: 0,
						HC: 15,
						Agua: 0,
						Calcio: 0,
						Fosforo: 125,
						Potasio: 0,
						Sodio: 90,
						Grupo: "Cereal s/g"
					},
					{
						Tipo: "Bajo",
						Cantidad: 0,
						KCal: 115,
						Proteina: 2,
						Lipidos: 5,
						HC: 15,
						Agua: 0,
						Calcio: 0,
						Fosforo: 20,
						Potasio: 0,
						Sodio: 80,
						Grupo: "C Y T c/g"
					},
					{
						Tipo: "Alto",
						Cantidad: 0,
						KCal: 115,
						Proteina: 2,
						Lipidos: 5,
						HC: 15,
						Agua: 0,
						Calcio: 0,
						Fosforo: 125,
						Potasio: 0,
						Sodio: 260,
						Grupo: "C Y T c/g"
					},
					{
						Tipo: "Bajo",
						Cantidad: 0,
						KCal: 120,
						Proteina: 8,
						Lipidos: 1,
						HC: 20,
						Agua: 0,
						Calcio: 0,
						Fosforo: 85,
						Potasio: 0,
						Sodio: 20,
						Grupo: "Leguminosas"
					},
					{
						Tipo: "Alto",
						Cantidad: 0,
						KCal: 120,
						Proteina: 8,
						Lipidos: 1,
						HC: 20,
						Agua: 0,
						Calcio: 0,
						Fosforo: 140,
						Potasio: 350,
						Sodio: 350,
						Grupo: "Leguminosas"
					},
					{
						Tipo: "Bajo",
						Cantidad: 0,
						KCal: 40,
						Proteina: 7,
						Lipidos: 1,
						HC: 0,
						Agua: 0,
						Calcio: 20,
						Fosforo: 40,
						Potasio: 0,
						Sodio: 40,
						Grupo: "AOA MBAG"
					},
					{
						Tipo: "Alto",
						Cantidad: 0,
						KCal: 40,
						Proteina: 7,
						Lipidos: 1,
						HC: 0,
						Agua: 0,
						Calcio: 200,
						Fosforo: 350,
						Potasio: 0,
						Sodio: 350,
						Grupo: "AOA MBAG"
					},
					{
						Tipo: "Bajo",
						Cantidad: 0,
						KCal: 55,
						Proteina: 7,
						Lipidos: 3,
						HC: 0,
						Agua: 0,
						Calcio: 20,
						Fosforo: 40,
						Potasio: 0,
						Sodio: 40,
						Grupo: "AOA BAG"
					},
					{
						Tipo: "Alto",
						Cantidad: 0,
						KCal: 55,
						Proteina: 7,
						Lipidos: 3,
						HC: 0,
						Agua: 0,
						Calcio: 200,
						Fosforo: 350,
						Potasio: 0,
						Sodio: 350,
						Grupo: "AOA BAG"
					},
					{
						Tipo: "Bajo",
						Cantidad: 0,
						KCal: 75,
						Proteina: 7,
						Lipidos: 5,
						HC: 0,
						Agua: 0,
						Calcio: 20,
						Fosforo: 40,
						Potasio: 0,
						Sodio: 40,
						Grupo: "AOA MG"
					},
					{
						Tipo: "Alto",
						Cantidad: 0,
						KCal: 75,
						Proteina: 7,
						Lipidos: 5,
						HC: 0,
						Agua: 0,
						Calcio: 200,
						Fosforo: 350,
						Potasio: 0,
						Sodio: 350,
						Grupo: "AOA MG"
					},
					{
						Tipo: "Bajo",
						Cantidad: 0,
						KCal: 100,
						Proteina: 7,
						Lipidos: 8,
						HC: 0,
						Agua: 0,
						Calcio: 20,
						Fosforo: 40,
						Potasio: 0,
						Sodio: 40,
						Grupo: "AOA AG"
					},
					{
						Tipo: "Alto",
						Cantidad: 0,
						KCal: 100,
						Proteina: 7,
						Lipidos: 8,
						HC: 0,
						Agua: 0,
						Calcio: 200,
						Fosforo: 350,
						Potasio: 0,
						Sodio: 350,
						Grupo: "AOA AG"
					},
					{
						Tipo: "Bajo",
						Cantidad: 0,
						KCal: 95,
						Proteina: 9,
						Lipidos: 2,
						HC: 12,
						Agua: 240,
						Calcio: 50,
						Fosforo: 15,
						Potasio: 0,
						Sodio: 100,
						Grupo: "Leche Descremada"
					},
					{
						Tipo: "Alto",
						Cantidad: 0,
						KCal: 95,
						Proteina: 9,
						Lipidos: 2,
						HC: 12,
						Agua: 240,
						Calcio: 250,
						Fosforo: 220,
						Potasio: 0,
						Sodio: 170,
						Grupo: "Leche Descremada"
					},
					{
						Tipo: "Bajo",
						Cantidad: 0,
						KCal: 110,
						Proteina: 9,
						Lipidos: 4,
						HC: 12,
						Agua: 240,
						Calcio: 50,
						Fosforo: 15,
						Potasio: 0,
						Sodio: 100,
						Grupo: "Leche Semidescremada"
					},
					{
						Tipo: "Alto",
						Cantidad: 0,
						KCal: 110,
						Proteina: 9,
						Lipidos: 4,
						HC: 12,
						Agua: 240,
						Calcio: 250,
						Fosforo: 220,
						Potasio: 0,
						Sodio: 170,
						Grupo: "Leche Semidescremada"
					},
					{
						Tipo: "Bajo",
						Cantidad: 0,
						KCal: 150,
						Proteina: 9,
						Lipidos: 8,
						HC: 12,
						Agua: 240,
						Calcio: 50,
						Fosforo: 15,
						Potasio: 0,
						Sodio: 100,
						Grupo: "Leche Entera"
					},
					{
						Tipo: "Alto",
						Cantidad: 0,
						KCal: 150,
						Proteina: 9,
						Lipidos: 8,
						HC: 12,
						Agua: 240,
						Calcio: 250,
						Fosforo: 220,
						Potasio: 0,
						Sodio: 170,
						Grupo: "Leche Entera"
					},
					{
						Tipo: "Bajo",
						Cantidad: 0,
						KCal: 200,
						Proteina: 8,
						Lipidos: 5,
						HC: 30,
						Agua: 240,
						Calcio: 50,
						Fosforo: 15,
						Potasio: 0,
						Sodio: 100,
						Grupo: "Leche con azucar"
					},
					{
						Tipo: "Alto",
						Cantidad: 0,
						KCal: 200,
						Proteina: 8,
						Lipidos: 5,
						HC: 30,
						Agua: 240,
						Calcio: 250,
						Fosforo: 220,
						Potasio: 0,
						Sodio: 170,
						Grupo: "Leche con azucar"
					},
					{
						Tipo: "Bajo",
						Cantidad: 0,
						KCal: 45,
						Proteina: 0,
						Lipidos: 5,
						HC: 0,
						Agua: 0,
						Calcio: 0,
						Fosforo: 0,
						Potasio: 0,
						Sodio: 25,
						Grupo: "Aceites y grasas s/p"
					},
					{
						Tipo: "Alto",
						Cantidad: 0,
						KCal: 45,
						Proteina: 0,
						Lipidos: 5,
						HC: 0,
						Agua: 0,
						Calcio: 0,
						Fosforo: 0,
						Potasio: 0,
						Sodio: 250,
						Grupo: "Aceites y grasas s/p"
					},
					{
						Tipo: "Bajo",
						Cantidad: 0,
						KCal: 70,
						Proteina: 3,
						Lipidos: 5,
						HC: 3,
						Agua: 0,
						Calcio: 0,
						Fosforo: 0,
						Potasio: 0,
						Sodio: 25,
						Grupo: "Aceites y grasas c/p"
					},
					{
						Tipo: "Alto",
						Cantidad: 0,
						KCal: 70,
						Proteina: 3,
						Lipidos: 5,
						HC: 3,
						Agua: 0,
						Calcio: 0,
						Fosforo: 0,
						Potasio: 0,
						Sodio: 250,
						Grupo: "Aceites y grasas c/p"
					},
					{
						Tipo: "Bajo",
						Cantidad: 0,
						KCal: 40,
						Proteina: 0,
						Lipidos: 0,
						HC: 10,
						Agua: 0,
						Calcio: 0,
						Fosforo: 0,
						Potasio: 0,
						Sodio: 20,
						Grupo: "Azúcares s/g"
					},
					{
						Tipo: "Alto",
						Cantidad: 0,
						KCal: 40,
						Proteina: 0,
						Lipidos: 0,
						HC: 10,
						Agua: 0,
						Calcio: 0,
						Fosforo: 0,
						Potasio: 0,
						Sodio: 550,
						Grupo: "Azúcares s/g"
					},
					{
						Tipo: "Bajo",
						Cantidad: 0,
						KCal: 85,
						Proteina: 0,
						Lipidos: 5,
						HC: 10,
						Agua: 0,
						Calcio: 0,
						Fosforo: 0,
						Potasio: 0,
						Sodio: 20,
						Grupo: "Azúcares c/g"
					},
					{
						Tipo: "Alto",
						Cantidad: 0,
						KCal: 85,
						Proteina: 0,
						Lipidos: 5,
						HC: 10,
						Agua: 0,
						Calcio: 0,
						Fosforo: 0,
						Potasio: 0,
						Sodio: 550,
						Grupo: "Azúcares c/g"
					}
				]
			}
		};
	},
	methods: {
		obtenerCatalogos() {
			// this.catalogos.Suplementos = this.$root.generarCatalogo([
			// 	"Nepro HP (237 ml)",
			// 	"Nepro LP (237 ml)",
			// 	"Enterex RNL (237 ml)",
			// 	"Fressuport RNL (66 g)",
			// 	"Ensure Regular (237 ml)",
			// 	"RenNut (70 g)",
			// 	"Supportan (200 ml)"
			// ]);
		},
		calcularTabla() {
			const props = [
				{ Prop: "KCal", PropRecomendacion: "RecomendacionEnergia" },
				{ Prop: "Proteina", PropRecomendacion: "TotalProteina" },
				{ Prop: "Lipidos", PropRecomendacion: "LipidosGramos" },
				{ Prop: "HC", PropRecomendacion: "HCGramos" },
				{ Prop: "Agua", PropRecomendacion: "RecomendacionAgua" },
				{ Prop: "Calcio", PropRecomendacion: "RecomendacionCalcio" },
				{ Prop: "Fosforo", PropRecomendacion: "RecomendacionFosforo" },
				{ Prop: "Potasio", PropRecomendacion: "RecomendacionPotasio" },
				{ Prop: "Sodio", PropRecomendacion: "RecomendacionSodio" }
			];
			props.forEach(prop => {
				const total = this.getTotal(prop.Prop);
				this.$set(this.valor.Totales, prop.Prop, total);
				this.$set(
					this.valor.Adecuaciones,
					prop.Prop,
					this.$root.formulas.adecuacionAlimento(
						total,
						this.valor[prop.PropRecomendacion]
					)
				);
			});
		},
		getTotal(prop) {
			let inicial = this.valor.Suplemento
				? this.valor.Suplemento[prop] * this.valor.Suplemento.Cantidad
				: 0;
			if (this.valor.SuplementosOtros) {
				const val = this.valor["SuplementosOtros_" + prop];
				if (val) {
					inicial += parseFloat(val);
				}
			}
			return this.valor.Alimentos.reduce((prev, curr, ix) => {
				return prev + curr.Cantidad * curr[[prop]];
			}, inicial);
		},
		ponerBordeInferior(alimento) {
			const ix = this.valor.Alimentos.indexOf(alimento);

			return (
				ix === this.valor.Alimentos.length - 1 ||
				this.valor.Alimentos[ix].Grupo !==
					this.valor.Alimentos[ix + 1].Grupo
			);
		},
		getRowSpan(alimento) {
			const ix = this.valor.Alimentos.indexOf(alimento);
			if (
				ix > 0 &&
				this.valor.Alimentos[ix - 1].Grupo ===
					this.valor.Alimentos[ix].Grupo
			) {
				return 0;
			}
			let rowSpan = 1;
			const grupo = this.valor.Alimentos[ix].Grupo;
			for (let i = ix + 1; i < this.valor.Alimentos.length; i++) {
				if (grupo === this.valor.Alimentos[i].Grupo) {
					rowSpan++;
				} else {
					break;
				}
			}
			return rowSpan;
		},
		calcularFormulas() {
			this.valor.EcuacionVilar = this.$root.formulas.ecuacionVilar(
				this.edad,
				this.peso,
				this.talla,
				this.esHombre
			);
			this.valor.KCal30 = this.$root.formulas.kCal30(this.peso);
			this.valor.KCal35 = this.$root.formulas.kCal35(this.peso);
			this.valor.TotalProteina = this.$root.formulas.totalProteina(
				this.peso,
				this.valor.Proteina
			);

			this.valor.ProteinaKcal = this.$root.formulas.kcalProteina(
				this.valor.ProteinaGramos
			);
			this.valor.ProteinaPorcentaje = this.$root.formulas.ptgProteina(
				this.valor.ProteinaKcal,
				this.valor.RecomendacionEnergia
			);
			this.valor.HCKcal = this.$root.formulas.kcalHidratosCarbono(
				this.valor.HCPorcentaje,
				this.valor.RecomendacionEnergia
			);
			this.valor.HCGramos = this.$root.formulas.gramosHidratosCarbono(
				this.valor.HCKcal
			);
			this.valor.LipidosPorcentaje = this.$root.formulas.ptgLipidos(
				this.valor.ProteinaPorcentaje,
				this.valor.HCPorcentaje
			);
			this.valor.LipidosKcal = this.$root.formulas.kcalLipidos(
				this.valor.LipidosPorcentaje,
				this.valor.RecomendacionEnergia
			);
			this.valor.LipidosGramos = this.$root.formulas.gramosLipidos(
				this.valor.LipidosKcal
			);
			this.valor.HarrisBenedict = this.$root.formulas.harrisBenedictGEB(
				this.peso,
				this.talla,
				this.edad
			);
		},
		anterior() {
			this.$emit("anterior");
		},
		siguiente() {
			this.$emit("siguiente");
		},
		async guardar() {
			if (this.$refs.formActual.validate()) {
				const res = await ServicioHistorialClinico.guardarPlanTerapeutico(
					this.historiaCliniciaId,
					this.valor
				);
				if (res.data.result === 1) {
					this.$root.mensajeExito = "Los cambios fueron guardados.";
					this.$router.back();
				} else {
					this.$root.mensajeError = res.data.message;
				}
			} else {
				this.$root.mensajeError =
					"Por favor llene los campos requeridos.";
			}
		}
	},
	mounted() {
		this.calcularTabla();
		this.calcularFormulas();
		this.obtenerCatalogos();
	},
	watch: {
		valor: {
			deep: true,
			handler() {
				this.calcularFormulas();
				this.calcularTabla();
			}
		},
		datosAntropometricos: {
			deep: true,
			handler() {
				this.calcularFormulas();
				this.calcularTabla();
			}
		},
		datos() {
			if (this.datos) {
				// this.valor = JSON.parse(this.datos);
				//typeof this.datos === "string" ? JSON.parse(this.datos) : this.datos;
				this.valor =
					typeof this.datos === "string"
						? JSON.parse(this.datos)
						: this.datos;
			}
		},
		validateForm() {
			if (this.validateForm) {
				if (!this.$refs.formActual.validate()) {
					this.$emit("valorCambiado", null);
				} else {
					this.$emit("valorCambiado", this.valor);
				}
			}
		}
	},
	computed: {
		historiaCliniciaId() {
			return this.$route.params.historiaClinicaId;
		},
		peso() {
			switch (this.valor.PesoInfo) {
				case 1:
					return this.datosAntropometricos.PesoSeco;
				case 2:
					return this.datosAntropometricos.PesoAustadoLibreEdema;
				case 3:
					return this.datosAntropometricos.PesoIdeal;
				default:
					return this.datosAntropometricos.PesoSeco;
			}
		},
		talla() {
			return this.datosAntropometricos.TallaCm;
		}
	}
};
</script>
<style>
.v-title {
	color: #1c62ad;
	font-size: 24px;
	font-weight: 400;
}
.borde-inferior {
	border-bottom: 1px solid #ccc;
}
table {
	border-collapse: collapse;
}
</style>
